export const INTERNAL_LANGUAGE_STORAGE_KEY = "internal_fleet_language";

const zh = {
  languageLabel: "语言",
  chinese: "中文",
  japanese: "日本語",
  productName: "車隊管理システム",
  companySystem: "湘南国際株式会社 内部管理系统",
  adminReturn: "返回管理员后台",
  collapseMenu: "折叠菜单",
  expandMenu: "展开菜单",
  logout: "退出登录",
  admin: "管理员",
  operator: "操作员",
  noPermissionTitle: "您没有权限访问此功能",
  noPermissionHint: "请联系管理员获取相应权限",
  nav: {
    dashboard: "仪表盘",
    vehicles: "车辆管理",
    drivers: "司机管理",
    dispatch: "调度总览",
    finances: "车辆财务",
    payroll: "工资明细",
    settings: "系统设置",
  },
  dashboard: {
    heading: "仪表盘",
    subtitle: "湘南国际内部车辆管理",
    totalVehicles: "车辆总数",
    activeVehicles: "运行中车辆",
    totalDrivers: "司机总数",
    activeDrivers: "在职司机",
    unpaidThisMonth: "本月未收款",
    monthlyRevenue: "本月売上（税抜）",
    vehicleUnit: "台",
    driverUnit: "名",
    itemUnit: "件",
    activeSub: "台运行中",
    stableSub: "稳定",
    employedSub: "名在职",
    fulltimeSub: "名全职",
    overdueSub: "件已过期",
    financeSub: "车辆财务集计",
    driverArrangements: "司机安排情况",
    dispatchRange: "调度总览",
    scheduledDrivers: "名有排班",
    noAssignments: "暂无司机排班",
    noVehicle: "车辆未指定",
    official: "正式",
    extra: "追加",
    noNext: "暂无下一条安排",
    routeMissing: "路线未填写",
    driverList: "司机一览",
    statusOverview: "状态总览",
    category: "区分",
    people: "人数",
    role: "角色",
    status: "状态",
    contact: "联系",
    active: "在职",
    fulltime: "全职",
    parttime: "兼职",
    suspended: "停职",
    available: "可运行",
    fixedDuty: "固定勤務",
    spotDuty: "临时勤務",
    stopped: "停止勤務",
    normal: "正常",
    confirm: "确认",
    stoppedStatus: "停止",
    managementDesk: "管理台",
    expiryAlerts: "到期提醒",
    needsAction: "项需处理",
    update: "更新",
    allValid: "所有证件均在有效期内",
    vehicleStatus: "车辆状态",
    maintenance: "维护中",
    retired: "已废弃",
    newOrder: "新增订单",
    dispatchVehicle: "车辆配车",
    addDriver: "新增司机",
    itinerary: "行程表",
    reportCenter: "报表中心",
    licenseExpiry: "驾照到期",
    insuranceExpiry: "保险到期",
    inspectionExpiry: "车检到期",
    quarterlyInspection: "三个月点检",
    healthCheckExpiry: "体检到期",
  },
  dispatch: {
    chip: "调度管理",
    title: "湘南国际调度管理系统",
    range: "调度总览",
    driverTotal: "司机总数",
    scheduledDrivers: "有排班司机",
    officialOrders: "正式订单",
    extraSchedules: "追加日程",
    overview: "司机运行状况总览",
    driver: "司机",
    official: "正式",
    driverExtra: "司机追加",
    dispatcherExtra: "调度追加",
    next: "下一条",
    noSchedule: "无排班",
    timeline: "近期调度时间线",
    emptyTimeline: "暂无调度日程",
    sources: {
      official: "正式订单",
      driver_extra: "司机追加",
      dispatcher_extra: "调度追加",
    },
  },
  common: {
    allStatuses: "全部状态",
    allTypes: "全部类型",
    add: "添加",
    edit: "编辑",
    delete: "删除",
    save: "保存",
    cancel: "取消",
    actions: "操作",
    status: "状态",
    noEditPermission: "您没有编辑权限",
    expired: "已过期",
    expiringSoon: "即将到期",
    incomplete: "未完成",
    unassigned: "-- 未分配 --",
    none: "无",
  },
  vehicles: {
    search: "搜索车牌号、原所有人...",
    hideInactive: "隐藏已废弃",
    addVehicle: "添加车辆",
    total: "车辆总数",
    active: "运行中",
    maintenance: "维护中",
    expiring: "保险/车检/点检即将到期",
    plate: "车牌号",
    vehicleType: "车型",
    assignedDriver: "负责司机",
    insuranceExpiry: "保险到期",
    inspectionExpiry: "车检到期",
    quarterlyInspection: "三个月点检",
    original: "原",
    empty: "暂无车辆数据",
    editTitle: "编辑车辆",
    addTitle: "添加车辆",
    activeStatus: "运行中",
    maintenanceStatus: "维护中",
    suspendedStatus: "暂停",
    retiredStatus: "已废弃",
    other: "其他",
    basicInsurance: "基础保险",
    fullInsurance: "升级全险",
  },
  drivers: {
    search: "搜索姓名、电话、驾照号...",
    hideInactive: "隐藏已停职",
    printSelected: "批量打印",
    addDriver: "添加司机",
    total: "司机总数",
    active: "在职",
    fulltime: "全职",
    parttimeTemporary: "兼职/短期",
    expiring: "证件即将到期",
    photo: "照片",
    name: "姓名",
    contact: "联系方式",
    employmentType: "雇佣类型",
    licenseExpiry: "驾照到期",
    healthExpiry: "体检到期",
    usualVehicle: "常用车辆",
    dispatchOverviewTarget: "调度总览显示",
    dispatchVisible: "显示",
    dispatchHidden: "隐藏",
    dispatchOverviewHint: "关闭后不会出现在仪表盘的司机安排情况中",
    empty: "暂无司机数据",
    editTitle: "编辑司机",
    addTitle: "添加司机",
    suspended: "停职",
    parttime: "兼职",
    temporary: "短期",
  },
  finances: {
    noVehiclesTitle: "暂无车辆",
    noVehiclesHint: "请先添加车辆，然后管理财务",
    unpaidCount: "笔未收款",
    income: "收入",
    expense: "支出",
    balance: "押金-未收款 差额",
    totalIncome: "总收入",
    totalExpense: "总支出",
    addIncome: "收入",
    addExpense: "支出",
    addUnpaid: "未收款",
    incomeItems: "收入项目",
    expenseItems: "支出项目",
    records: "条",
    unpaid: "未支付",
    paid: "已收款",
    emptyIncome: "暂无收入记录",
    emptyExpense: "暂无支出记录",
    deletedRecords: "已删除的记录",
    addIncomeTitle: "添加收入",
    addExpenseTitle: "添加支出",
    addUnpaidTitle: "添加未收款项",
    category: "分类",
    itemName: "项目名称",
    optional: "选填",
    amount: "金额",
    currency: "币种",
    notes: "备注",
  },
  settings: {
    users: "用户管理",
    email: "邮件提醒",
    password: "修改密码",
    company: "公司信息",
    system: "系统设置",
  },
};

const ja = {
  ...zh,
  languageLabel: "表示言語",
  companySystem: "湘南国際株式会社 社内管理システム",
  adminReturn: "管理画面へ戻る",
  collapseMenu: "メニューを折りたたむ",
  expandMenu: "メニューを展開",
  logout: "ログアウト",
  admin: "管理者",
  operator: "オペレーター",
  noPermissionTitle: "この機能を利用する権限がありません",
  noPermissionHint: "必要な権限は管理者へ確認してください",
  nav: {
    dashboard: "ダッシュボード",
    vehicles: "車両管理",
    drivers: "乗務員管理",
    dispatch: "配車総覧",
    finances: "車両財務",
    payroll: "給与明細",
    settings: "システム設定",
  },
  dashboard: {
    ...zh.dashboard,
    heading: "ダッシュボード",
    subtitle: "湘南国際 社内車両管理",
    totalVehicles: "総車両数",
    activeVehicles: "稼働中車両",
    totalDrivers: "乗務員総数",
    activeDrivers: "在職乗務員",
    unpaidThisMonth: "当月未収",
    vehicleUnit: "台",
    driverUnit: "名",
    itemUnit: "件",
    activeSub: "台稼働中",
    stableSub: "安定",
    employedSub: "名在職",
    fulltimeSub: "名正社員",
    overdueSub: "件期限切れ",
    financeSub: "車両財務集計",
    driverArrangements: "乗務員配車状況",
    dispatchRange: "配車総覧",
    scheduledDrivers: "名配車あり",
    noAssignments: "配車予定はありません",
    noVehicle: "車両未指定",
    noNext: "次の予定はありません",
    routeMissing: "経路未入力",
    driverList: "乗務員一覧",
    statusOverview: "状態総覧",
    category: "区分",
    people: "人数",
    role: "役割",
    status: "状態",
    contact: "連絡先",
    active: "在職",
    fulltime: "正社員",
    parttime: "パート",
    suspended: "停止",
    available: "稼働可能",
    fixedDuty: "固定勤務",
    spotDuty: "スポット勤務",
    stopped: "勤務停止",
    normal: "正常",
    confirm: "確認",
    stoppedStatus: "停止",
    managementDesk: "管理台",
    expiryAlerts: "期限アラート",
    needsAction: "件要対応",
    update: "更新",
    allValid: "すべて有効期限内です",
    vehicleStatus: "車両状態",
    maintenance: "整備中",
    retired: "廃車",
    newOrder: "新規注文",
    dispatchVehicle: "車両配車",
    addDriver: "乗務員追加",
    itinerary: "行程表",
    reportCenter: "帳票センター",
    licenseExpiry: "免許期限",
    insuranceExpiry: "保険期限",
    inspectionExpiry: "車検期限",
    quarterlyInspection: "3か月点検",
    healthCheckExpiry: "健康診断期限",
  },
  dispatch: {
    chip: "配車管理",
    title: "湘南国際配車管理システム",
    range: "配車総覧",
    driverTotal: "乗務員総数",
    scheduledDrivers: "配車あり",
    officialOrders: "正式注文",
    extraSchedules: "追加日程",
    overview: "乗務員稼働状況総覧",
    driver: "乗務員",
    official: "正式",
    driverExtra: "乗務員追加",
    dispatcherExtra: "配車追加",
    next: "次の予定",
    noSchedule: "予定なし",
    timeline: "直近配車タイムライン",
    emptyTimeline: "配車日程はありません",
    sources: {
      official: "正式注文",
      driver_extra: "乗務員追加",
      dispatcher_extra: "配車追加",
    },
  },
  common: {
    allStatuses: "すべての状態",
    allTypes: "すべての区分",
    add: "追加",
    edit: "編集",
    delete: "削除",
    save: "保存",
    cancel: "キャンセル",
    actions: "操作",
    status: "状態",
    noEditPermission: "編集権限がありません",
    expired: "期限切れ",
    expiringSoon: "期限間近",
    incomplete: "未完了",
    unassigned: "-- 未割当 --",
    none: "なし",
  },
  vehicles: {
    search: "車両番号・旧所有者を検索...",
    hideInactive: "廃車・停止を非表示",
    addVehicle: "車両追加",
    total: "車両総数",
    active: "稼働中",
    maintenance: "整備中",
    expiring: "保険・車検・点検期限間近",
    plate: "車両番号",
    vehicleType: "車種",
    assignedDriver: "担当乗務員",
    insuranceExpiry: "保険期限",
    inspectionExpiry: "車検期限",
    quarterlyInspection: "3か月点検",
    original: "旧",
    empty: "車両データはありません",
    editTitle: "車両を編集",
    addTitle: "車両を追加",
    activeStatus: "稼働中",
    maintenanceStatus: "整備中",
    suspendedStatus: "停止",
    retiredStatus: "廃車",
    other: "その他",
    basicInsurance: "基本保険",
    fullInsurance: "上位保険",
  },
  drivers: {
    search: "氏名・電話・免許番号を検索...",
    hideInactive: "停止中を非表示",
    printSelected: "一括印刷",
    addDriver: "乗務員追加",
    total: "乗務員総数",
    active: "在職",
    fulltime: "正社員",
    parttimeTemporary: "パート・短期",
    expiring: "証明書期限間近",
    photo: "写真",
    name: "氏名",
    contact: "連絡先",
    employmentType: "雇用区分",
    licenseExpiry: "免許期限",
    healthExpiry: "健康診断期限",
    usualVehicle: "通常車両",
    dispatchOverviewTarget: "配車総覧に表示",
    dispatchVisible: "表示",
    dispatchHidden: "非表示",
    dispatchOverviewHint: "オフにするとダッシュボードの配車状況に表示されません",
    empty: "乗務員データはありません",
    editTitle: "乗務員を編集",
    addTitle: "乗務員を追加",
    suspended: "停止",
    parttime: "パート",
    temporary: "短期",
  },
  finances: {
    noVehiclesTitle: "車両がありません",
    noVehiclesHint: "先に車両を追加してから財務を管理してください",
    unpaidCount: "件未収",
    income: "収入",
    expense: "支出",
    balance: "保証金 - 未収 差額",
    totalIncome: "総収入",
    totalExpense: "総支出",
    addIncome: "収入",
    addExpense: "支出",
    addUnpaid: "未収",
    incomeItems: "収入項目",
    expenseItems: "支出項目",
    records: "件",
    unpaid: "未収",
    paid: "入金済",
    emptyIncome: "収入記録はありません",
    emptyExpense: "支出記録はありません",
    deletedRecords: "削除済み記録",
    addIncomeTitle: "収入を追加",
    addExpenseTitle: "支出を追加",
    addUnpaidTitle: "未収項目を追加",
    category: "分類",
    itemName: "項目名",
    optional: "任意",
    amount: "金額",
    currency: "通貨",
    notes: "備考",
  },
  settings: {
    users: "ユーザー管理",
    email: "メール通知",
    password: "パスワード変更",
    company: "会社情報",
    system: "システム設定",
  },
};

export const INTERNAL_FLEET_COPY = { zh, ja };

export function getInternalFleetCopy(language) {
  return INTERNAL_FLEET_COPY[language] || INTERNAL_FLEET_COPY.zh;
}
